$(document).ready(function () {
  $('.flipper').removeClass('flipped');

  $('.spec-btn.black').addClass('active');

  $('.spec-btn.black').click(function () {
    $('.flipper').removeClass('flipped');

    $('.spec-btn').removeClass('active');
    $(this).addClass('active');
  });

  $('.spec-btn.outline').click(function () {
    $('.flipper').addClass('flipped');

    $('.spec-btn').removeClass('active');
    $(this).addClass('active');
  });
// Contact Popup
$('.enquiry-btn').on('click', function () {

        var product = $(this).data('product');

        $('#popup-title').html(
            'Enquiry for <br><strong>' + product + '</strong>'
        );

        $('#popup-email').attr(
            'href',
            'mailto:admin@modburybattery.com.au?subject=' + encodeURIComponent('Enquiry for ' + product)
        );

        $('#enquiry-popup').addClass('active');
         $('body').addClass('enquiry-popup-active');
    });

    $('.popup-close, .enquiry-popup__overlay').on('click', function () {
        $('#enquiry-popup').removeClass('active');
         $('body').removeClass('enquiry-popup-active');
    });
// Contact Popup

});